module.exports = __webpack_public_path__ + "img/activity.dc13e6e0.svg";